/**
 * Применение темы к документу
 * # ⛓️ CURSOR_ANCHOR:ui:theme-application
 */

(function() {
  'use strict';

  var THEME_LIGHT = window.THEME_CONSTANTS.LIGHT;
  var THEME_DARK = window.THEME_CONSTANTS.DARK;
  var THEME_AUTO = window.THEME_CONSTANTS.AUTO;

  /**
   * Обновить meta theme-color для мобильных браузеров
   */
  function updateThemeColor(theme) {
    var metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      if (theme === THEME_DARK) {
        metaThemeColor.setAttribute('content', '#1a1a1a');
      } else {
        metaThemeColor.setAttribute('content', '#426B1D');
      }
    }
  }

  /**
   * Функция для принудительного пересчета стилей
   */
  function forceStyleRecalc(html, body, effectiveTheme) {
    if (body) {
      // Принудительный reflow без скрытия (скрытие вызывало "дерганье" интерфейса)
      body.offsetHeight;
    }
    
    // Проверяем результат
    var currentAttr = html.getAttribute('data-theme');
    
    if (effectiveTheme === THEME_DARK && currentAttr !== 'dark') {
      html.setAttribute('data-theme', 'dark');
    } else if (effectiveTheme === THEME_LIGHT && currentAttr === 'dark') {
      html.removeAttribute('data-theme');
    }
  }

  /**
   * Применить тему к документу
   */
  function applyTheme(theme) {
    var effectiveTheme = theme === THEME_AUTO ? window.THEME_DETECTION.getEffective() : theme;
    var profile = window.THEME_STORAGE.getProfile();
    var html = document.documentElement;
    var body = document.body;
    
    // 1. Устанавливаем профиль (синхронно)
    html.setAttribute('data-color-profile', profile);
    
    // 2. Устанавливаем тему (синхронно для мгновенного обновления)
    if (effectiveTheme === THEME_DARK) {
      html.setAttribute('data-theme', 'dark');
    } else {
      html.setAttribute('data-theme', 'light');
    }
    
    // 3. Принудительный пересчет (если нужен)
    forceStyleRecalc(html, body, effectiveTheme);
    
    // 4. Обновляем meta theme-color
    updateThemeColor(effectiveTheme);
  }

  window.THEME_APPLICATION = {
    apply: applyTheme,
    updateThemeColor: updateThemeColor
  };
})();

